module.exports = __webpack_public_path__ + "img/breakintotech.ece6ca92.png";